<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <loading-spinner v-if="isLoading"></loading-spinner>
        <!-- TODO: 검증로직 추가 -->
        <v-form v-else ref="form" v-model="isValid">
          <v-card class="rounded-lg">
            <card-header
              :title="$t('title.journal_create')"
              icon="menu"
              color="primary"
              variant="gradient"
            ></card-header>

            <v-card-text>
              <v-row>
                <v-col class="d-flex justify-center align-center">
                  <!-- 숨겨진 파일 입력 -->
                  <input
                    ref="fileInput"
                    type="file"
                    accept="image/*"
                    @change="handleFileChange"
                    style="display: none"
                  />

                  <!-- 클릭 가능한 카드 영역 -->
                  <v-card
                    width="200"
                    height="250"
                    class="image-upload-card d-flex justify-center align-center"
                    @click="triggerFileInput"
                  >
                    <template v-if="imagePreview">
                      <v-img
                        :src="imagePreview"
                        max-width="200"
                        max-height="250"
                        contain
                      >
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height ma-0"
                            align="center"
                            justify="center"
                          >
                            <v-progress-circular
                              indeterminate
                            ></v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                    </template>
                    <template v-else>
                      <div class="text-center">
                        <v-icon size="64" color="grey lighten-1"
                          >mdi-image-plus</v-icon
                        >
                        <div class="mt-2 grey--text">
                          {{ $t("txt.click_to_upload") }}
                        </div>
                      </div>
                    </template>
                  </v-card>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6">
                  <v-select
                    v-model="journal.journal_type_idx"
                    :label="$t('label.journal_category')"
                    :item-value="(item) => item.idx"
                    :item-text="(item) => item.name"
                    :items="journalTypes"
                    prepend-icon="book"
                    :rules="[rules.required]"
                  ></v-select>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6">
                  <v-text-field
                    v-model="journal.title"
                    :label="$t('label.journal_title')"
                    prepend-icon="title"
                    :rules="[rules.required]"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6">
                  <v-text-field
                    v-model="journal.title_eng"
                    :label="$t('label.journal_title_eng')"
                    prepend-icon="title"
                    :rules="[rules.required]"
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-row v-show="isJournalType">
                <v-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6">
                  <v-text-field
                    v-model="journal.issn"
                    :label="$t('label.journal_issn')"
                    prepend-icon="notes"
                    :rules="isJournalType ? [rules.required] : []"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6">
                  <v-text-field
                    v-model="journal.eissn"
                    :label="$t('label.journal_eissn')"
                    prepend-icon="notes"
                    :rules="isJournalType ? [rules.required] : []"
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6">
                  <default-date-picker
                    v-model="journal.submission_start_date"
                    :label="$t('label.journal_submission_start_date')"
                    :rules="[rules.required]"
                  ></default-date-picker>
                </v-col>

                <v-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6">
                  <default-date-picker
                    v-model="journal.submission_end_date"
                    :label="$t('label.journal_submission_end_date')"
                    :rules="[rules.required]"
                  ></default-date-picker>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6">
                  <v-select
                    v-model="journal.research_ethics_statement"
                    :label="$t('label.research_ethics_statement')"
                    :item-value="(item) => item.idx"
                    :item-text="(item) => item.title"
                    :items="researchEthicsStatements"
                    prepend-icon="notes"
                    :rules="[rules.required]"
                  ></v-select>
                </v-col>
                <v-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6">
                  <v-select
                    v-model="journal.copyright_transfer_agreement"
                    :label="$t('label.copyright_transfer_agreement')"
                    :item-value="(item) => item.idx"
                    :item-text="(item) => item.title"
                    :items="copyrightTransferAgreements"
                    prepend-icon="notes"
                    :rules="[rules.required]"
                  ></v-select>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6">
                  <v-select
                    v-model="journal.plagiarism_check_agreement"
                    :label="$t('label.plagiarism_check_agreement')"
                    :item-value="(item) => item.idx"
                    :item-text="(item) => item.title"
                    :items="plagiarismCheckAgreements"
                    prepend-icon="notes"
                    :rules="[rules.required]"
                  ></v-select>
                </v-col>

                <v-col
                  cols="12"
                  xs="12"
                  sm="6"
                  md="6"
                  lg="6"
                  xl="6"
                  class="mt-4"
                >
                  <default-date-picker
                    v-model="journal.publish_date"
                    :label="$t('label.journal_publish_date')"
                    :rules="[rules.required]"
                  ></default-date-picker>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6">
                  <v-text-field
                    v-model="journal.year"
                    :label="$t('label.journal_year')"
                    type="number"
                    prepend-icon="notes"
                    disabled
                  ></v-text-field>
                </v-col>
                <v-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6">
                  <v-text-field
                    v-model="journal.volume"
                    :label="$t('label.journal_volume')"
                    type="number"
                    prepend-icon="notes"
                    :rules="[rules.required]"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6">
                  <v-text-field
                    v-model="journal.issue"
                    :label="$t('label.journal_issue')"
                    type="number"
                    prepend-icon="notes"
                    :rules="[rules.required]"
                  ></v-text-field>
                </v-col>
                <v-col
                  cols="12"
                  xs="12"
                  sm="6"
                  md="6"
                  lg="6"
                  xl="6"
                  v-show="isJournalType"
                >
                  <v-text-field
                    v-model="journal.doi_suffix"
                    :label="$t('label.journal_doi_suffix')"
                    prepend-icon="notes"
                    :rules="isJournalType ? [rules.required] : []"
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12">
                  <v-textarea
                    v-model="journal.description"
                    :label="$t('label.journal_description')"
                    outlined
                    dense
                    :rules="[rules.required]"
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-card-text>

            <v-card-actions class="d-flex align-center justify-space-between">
              <custom-button
                @click="toJournalManagement"
                :label="$t('button.cancel')"
                color="black"
                size="lg"
                gradient
                rounded
              ></custom-button>
              <custom-button
                @click="saveJournal"
                :disabled="!isValid"
                :label="$t('button.save')"
                color="primary"
                size="lg"
                gradient
                rounded
              ></custom-button>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import CardHeader from "@/components/cards/CardHeader.vue";
import CustomButton from "@/components/common/buttons/CustomButton.vue";
import DefaultDatePicker from "@/components/common/Pickers/DefaultDatePicker.vue";
import LoadingSpinner from "@/components/common/Spinners/LoadingSpinner.vue";
import {
  journalTypeApi,
  consentDocumentApi,
  journalApi,
  fileApi,
} from "@/api/api";
import { confirmClosePopup, confirmSavePopup } from "@/fields/journal/popups";

export default {
  components: {
    CardHeader,
    CustomButton,
    DefaultDatePicker,
    LoadingSpinner,
  },
  data() {
    return {
      isValid: false,
      journal: {
        title: "",
        title_eng: "",
        journal_type_idx: "",
        image_path: null,
        description: "",
        issn: null,
        eissn: null,
        year: null,
        volume: null,
        issue: null,
        doi_suffix: null,
        research_ethics_statement: null,
        copyright_transfer_agreement: null,
        plagiarism_check_agreement: null,
        submission_start_date: "",
        submission_end_date: "",
        publish_date: "",
      },
      journalTypes: [],
      researchEthicsStatements: [],
      copyrightTransferAgreements: [],
      plagiarismCheckAgreements: [],
      rules: {
        required: (value) => !!value || this.$t("valid.required_field"),
      },
      invalid: false,
      isLoading: false,
      imagePreview: null,
      journalImage: null,
    };
  },
  computed: {
    isJournalType() {
      const selectedType = this.journalTypes.find(
        (type) => type.idx === this.journal.journal_type_idx
      );
      return selectedType?.code === "jnl";
    },

    journalYear() {
      if (this.journal.publish_date) {
        return this.journal.publish_date.year;
      }
      return null;
    },
  },
  watch: {
    "journal.journal_type_idx"(newVal) {
      const selectedType = this.journalTypes.find(
        (type) => type.idx === newVal
      );
      if (selectedType?.code !== "jnl") {
        this.journal.issn = null;
        this.journal.eissn = null;
      }
    },
    "journal.publish_date"(newVal) {
      if (typeof newVal === "string") {
        const date = new Date(newVal);
        if (!isNaN(date)) {
          this.journal.year = date.getFullYear();
        }
      }
    },
  },
  methods: {
    triggerFileInput() {
      this.$refs.fileInput.click();
    },

    handleFileChange(event) {
      const file = event.target.files[0];

      if (file) {
        this.journalImage = file;
        this.previewImage(file);
      }
    },
    previewImage(file) {
      if (!file) {
        this.imagePreview = null;
        return;
      }
      this.imagePreview = URL.createObjectURL(file);
    },

    async saveJournal() {
      const isConfirm = await confirmSavePopup();

      if (isConfirm) {
        const isValid = await this.$refs.form.validate();

        if (isValid) {
          await this.createJournal();
          this.$router.push({ name: "journals-management" });
        }
      }
    },
    async toJournalManagement() {
      const isConfirm = await confirmClosePopup();

      if (isConfirm) {
        this.$router.push({ name: "journals-management" });
      }
    },
    /* **********************************************************************************
     * API 호출
     * ********************************************************************************** */
    async createJournal() {
      this.isLoading = true;

      try {
        // 이미지가 있다면 먼저 업로드
        if (this.journalImage) {
          await this.uploadFile();
        }

        const body = {
          title: this.journal.title,
          title_eng: this.journal.title_eng,
          journal_type_idx: this.journal.journal_type_idx,
          image_path: this.journal.image_path,
          description: this.journal.description,
          issn: this.journal.issn,
          eissn: this.journal.eissn,
          year: this.journal.year,
          volume: this.journal.volume,
          issue: this.journal.issue,
          doi_suffix: this.journal.doi_suffix,
          consent_document_idxs: [
            this.journal.research_ethics_statement,
            this.journal.copyright_transfer_agreement,
            this.journal.plagiarism_check_agreement,
          ],
          submission_start_date: this.journal.submission_start_date,
          submission_end_date: this.journal.submission_end_date,
          publish_date: this.journal.publish_date,
        };
        const response = await journalApi.createJournal(body);
        if (response.status === 201) {
          this.notifyVue({
            message: this.$t("alert.success_create_journal"),
            style: "success",
          });
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error);
        this.notifyVue({
          message: this.$t("alert.failed_request"),
          style: "danger",
        });
        this.$router.push({ name: "dashboard" });
      } finally {
        this.isLoading = false;
      }
    },

    async uploadFile() {
      try {
        const formData = new FormData();
        formData.append("file", this.journalImage);
        formData.append("category", "journal");

        const response = await fileApi.uploadFile(formData);
        if (response.status === 200) {
          this.journal.image_path = response.data.path;
        }
      } catch (error) {
        this.notifyVue({
          message: this.$t("alert.failed_request"),
          style: "danger",
        });
      }
    },

    async fetchJournalTypes() {
      this.isLoading = true;
      try {
        const response = await journalTypeApi.showAll();
        if (response.status === 200) {
          this.journalTypes = response.data.response;
        }
      } catch (error) {
        this.notifyVue({
          message: this.$t("alert.failed_request"),
          style: "danger",
        });
        this.$router.push({ name: "dashboard" });
      } finally {
        this.isLoading = false;
      }
    },

    async fetchConsentDocumentByType(code) {
      this.isLoading = true;
      try {
        const response = await consentDocumentApi.showAll({
          consent_document_type_code: code,
        });
        if (response.status === 200) {
          return response.data.response;
        }
      } catch (error) {
        this.notifyVue({
          message: this.$t("alert.failed_request"),
          style: "danger",
        });
        this.$router.push({ name: "dashboard" });
      } finally {
        this.isLoading = false;
      }
    },

    /* ****************************************************************************************
     * 알럿
     * ****************************************************************************************/
    notifyVue({
      vertical = "top",
      horizontal = "right",
      message = "",
      style = "primary",
      icon = "priority_high",
    } = {}) {
      this.$notify({
        timeout: 8000,
        message: message,
        icon: icon,
        type: style,
        horizontalAlign: horizontal,
        verticalAlign: vertical,
      });
    },
  },
  async mounted() {
    await this.fetchJournalTypes();
    this.researchEthicsStatements = await this.fetchConsentDocumentByType(
      "research_ethics_statement"
    );
    this.copyrightTransferAgreements = await this.fetchConsentDocumentByType(
      "copyright_transfer_agreement"
    );
    this.plagiarismCheckAgreements = await this.fetchConsentDocumentByType(
      "plagiarism_check_agreement"
    );
  },
  beforeDestroy() {
    if (this.imagePreview) {
      URL.revokeObjectURL(this.imagePreview);
    }
  },
};
</script>

<style scoped>
.image-upload-card {
  border: 2px dashed #e0e0e0;
  transition: all 0.3s;
  overflow: hidden;
  cursor: pointer;
}

.image-upload-card:hover {
  border-color: #1976d2;
  background-color: #f5f5f5;
}

.image-upload-card .v-icon {
  transition: all 0.3s;
}

.image-upload-card:hover .v-icon {
  color: #1976d2 !important;
  transform: scale(1.1);
}
</style>
